<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div
            class="w-100 d-flex flex-column flex-md-row justify-content-between mb-3"
          >
            <h1>
              {{ $route.params.id ? "ویرایش" : "ایجاد" }}
              نقشه راه
              <template
                v-if="
                  roadmapDetails &&
                  roadmapDetails.user &&
                  roadmapDetails.user.fullName
                "
              >
                <b-link :to="`/users/${roadmapDetails.studentUserId}`">
                  {{ roadmapDetails.user.fullName }}
                </b-link>
              </template>
              <template v-else>
                <b-link :to="`/users/${userDetails.userId}`">
                  {{ userDetails.fullName }}
                </b-link>
              </template>
            </h1>
            <b-button
              v-b-modal.modal-delete-confirm
              v-if="$route.params.id"
              type="button"
              variant="danger"
              class="flex-shrink-0"
            >
              حذف نقشه راه
            </b-button>
          </div>
          <b-row>
            <b-col cols="12">
              <b-row>
                <template v-if="lessonsList && lessonsList.length > 0">
                  <b-col cols="12" class="mb-2">
                    <h2>انتخاب درس های مورد نظر</h2>
                  </b-col>
                  <b-col
                    cols="12"
                    sm="4"
                    v-for="(lesson, index) in sortedLessonList"
                    :key="lesson.id"
                  >
                    <b-card
                      :border-variant="selectedBorderClass(lesson.lessonId)"
                      style="cursor: pointer"
                      @click="selectLesson(lesson)"
                    >
                      {{ lesson.title }}
                    </b-card>
                  </b-col>
                </template>
                <template v-else-if="lessonsList && lessonsList.length == 0">
                  <b-col cols="12">
                    <p class="text-center">هیچ درسی در این زبان وجود ندارد!</p>
                  </b-col>
                </template>
              </b-row>
            </b-col>
            <b-col cols="12">
              <div class="mb-2">
                <h3>درس های انتخاب شده</h3>
                <hr />
              </div>
              <draggable
                v-if="sortedSelectedLessons && sortedSelectedLessons.length > 0"
                :scroll-sensitivity="550"
                handle=".handler"
                v-model="selectedLessons"
                :force-fallback="true"
                @end="setNewOrder"
                class="w-full col-span-5"
              >
                <div class="my-2">
                  <div
                    class="d-flex flex-column flex-lg-row align-items-md-center justify-content-md-between"
                    style="gap: 1rem"
                  >
                    <feather-icon
                      style="
                        cursor: default;
                        width: 20px;
                        height: 20px;
                        min-width: 20px;
                        min-height: 20px;
                        visibility: hidden;
                      "
                      icon="MenuIcon"
                      class="text-primary handler mr-2"
                      size="20"
                    />
                    <div
                      class="mb-0"
                      style="
                        min-width: 10rem !important;
                        width: 10rem !important;
                        max-width: 10rem !important;
                        visibility: hidden;
                        cursor: default;
                      "
                    >
                      فasdf asdf asdfasdثسف
                    </div>

                    <b-form-checkbox
                      switch
                      @change="makeAllPassed"
                      :checked="isAllPassed"
                    >
                      <small>
                        قبولی همه ({{ isAllPassed ? "بله" : "خیر" }})
                      </small>
                    </b-form-checkbox>

                    <b-form-checkbox
                      switch
                      @change="makeAllBought"
                      :checked="isAllBought"
                    >
                      <small
                        >خریداری همه ({{ isAllBought ? "بله" : "خیر" }})</small
                      >
                    </b-form-checkbox>

                    <b-form-checkbox
                      @change="makeAllRequired"
                      :checked="isAllRequired"
                      switch
                    >
                      <small>
                        اجباری همه ({{ isAllRequired ? "بله" : "خیر" }})
                      </small>
                    </b-form-checkbox>
                    <span style="visibility: hidden; cursor: default">
                      <feather-icon
                        icon="Trash2Icon"
                        size="20"
                        class="text-danger"
                      />
                    </span>
                  </div>
                </div>
                <div
                  v-for="lesson in sortedSelectedLessons"
                  :key="lesson.priority"
                  class="my-2"
                >
                  <div
                    class="d-flex flex-column flex-lg-row align-items-md-center justify-content-md-between"
                    style="gap: 1rem"
                  >
                    <feather-icon
                      style="
                        cursor: pointer;
                        width: 20px;
                        height: 20px;
                        min-width: 20px;
                        min-height: 20px;
                      "
                      icon="MenuIcon"
                      class="text-primary handler mr-2"
                      size="20"
                    />
                    <b-link
                      :to="`/independent-lessons/${lesson.lessonId}`"
                      class="mb-0"
                      style="
                        min-width: 10rem !important;
                        width: 10rem !important;
                        max-width: 10rem !important;
                      "
                    >
                      {{
                        lesson.lessonTitle && lesson.lessonTitle != ""
                          ? lesson.lessonTitle
                          : lesson.title
                      }}
                    </b-link>

                    <b-form-checkbox
                      switch
                      @change="setProperStatus($event, lesson)"
                      :id="`isPassed${lesson.lessonId}`"
                      :checked="lesson.examStatus == 4"
                    >
                      <small
                        >قبول شده ({{
                          lesson.examStatus == 4 ? "بله" : "خیر"
                        }})</small
                      >
                    </b-form-checkbox>

                    <b-form-checkbox
                      switch
                      v-model="lesson.isUserPayed"
                      :id="`isUserPayed${lesson.lessonId}`"
                    >
                      <small
                        >خریداری شده؟ ({{
                          lesson.isUserPayed ? "بله" : "خیر"
                        }})</small
                      >
                    </b-form-checkbox>

                    <b-form-checkbox
                      switch
                      v-model="lesson.isRequired"
                      :id="`isRequired${lesson.lessonId}`"
                    >
                      <small
                        >جلسه اجباری ({{
                          lesson.isRequired ? "بله" : "خیر"
                        }})</small
                      >
                    </b-form-checkbox>
                    <span class="cursor-pointer" @click="removeLesson(lesson)">
                      <feather-icon
                        icon="Trash2Icon"
                        size="20"
                        class="text-danger"
                      />
                    </span>
                  </div>
                </div>
              </draggable>
              <p v-else class="text-center">درسی انتخاب نشده است.</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div
                class="w-100 d-flex align-items-center justify-content-end mt-2"
              >
                <b-button variant="success" @click="createOrUpdateRoadmap">
                  ثبت
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <!-- Delete Confirmation Modal Start -->
    <b-modal
      title="حذف نقشه راه"
      id="modal-delete-confirm"
      centered
      ok-variant="danger"
      ok-title="بله"
      cancel-title="خیر"
      @ok="deleteASingleRoadmapById"
    >
      <b-container fluid>
        <b-form-row>
          <b-col cols="12">
            <p>آیا از حذف این نقشه راه اطمینان دارید؟</p>
          </b-col>
        </b-form-row>
      </b-container>
    </b-modal>
    <!-- Delete Confirmation Modal End -->
  </b-overlay>
</template>

<script>
export default {
  async mounted() {
    if (this.$route.params.userId) {
      this.roadmapDetails.studentUserId = this.$route.params.userId;
      this.roadmapDetails.languageId = this.$route.params.langId;
      this.getUserDetails();
    }
    await this.getASingleRoadmapById();
    this.getAllIndependentLessons();
  },
  data() {
    return {
      isLoading: false,
      roadmapDetails: {
        id: null,
        studentUserId: null,
        languageId: 0,
        status: 1,
        isGraduated: false,
        studentLanguageId: null,
        roadMapGroupSimpleCreateUpdateDetaileDTOs: [],
      },
      selectedLessons: [],
      lessonsList: null,
      studentLanguageDetails: null,
      userDetails: null,
    };
  },
  methods: {
    setProperStatus(isChecked, lesson) {
      if (isChecked) {
        lesson["examStatus"] = 4;
      } else {
        lesson["examStatus"] = null;
      }
    },
    async getUserDetails() {
      try {
        this.isLoading = true;
        let _this = this;
        let getLiteUserById = new GetLiteUserById(_this);
        getLiteUserById.setRequestParam({
          id: _this.$route.params.userId,
        });
        await getLiteUserById.fetch((res) => {
          _this.userDetails = res;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async createOrUpdateRoadmap() {
      try {
        this.roadmapDetails.roadMapGroupSimpleCreateUpdateDetaileDTOs =
          this.selectedLessons;
        this.isLoading = true;
        let _this = this;
        let createOrUpdateRoadmap = new CreateOrUpdateRoadmap(_this);
        createOrUpdateRoadmap.setRequestParamDataObj(_this.roadmapDetails);
        await createOrUpdateRoadmap.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ثبت شد",
                icon: "CheckIcon",
                variant: "success",
                text: "نقشه راه با موفقیت بروز شد",
              },
            });
            _this.$router.push("/students/roadmaps/list");
            _this.getASingleRoadmapById();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.message || "لطفا دوباره امتحان کنید!",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    removeLesson(lesson) {
      this.selectedLessons = this.selectedLessons.filter(
        (item) => item != lesson
      );
    },
    async getAllIndependentLessons() {
      let _this = this;
      let getIndependentLessonsList = new GetIndependentLessonsList(_this);
      getIndependentLessonsList.setRequestParamDataObj({
        count: 100,
        pageNumber: 1,
        languageId: _this.$route.params.id
          ? _this.roadmapDetails.languageId
          : _this.$route.params.langId,
      });
      await getIndependentLessonsList.fetch(
        function (response) {
          _this.lessonsList = response.data;
          _this.lessonsList.forEach((item) => {
            item["lessonId"] = item.id;
            item.id = null;
          });
        },
        function (error) {
          console.error(error);
        }
      );
    },
    arrayMove(arr, old_index, new_index) {
      //   var tempPrio = arr[new_index].priority;
      //   arr[new_index].priority = arr[old_index].priority;
      //   arr[old_index].priority = tempPrio;
      if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      arr.forEach((item, index) => (item.priority = index + 1));
    },
    selectLesson(lesson) {
      if (
        this.selectedLessons.findIndex(
          (item) => item.lessonId == lesson.lessonId
        ) == -1
      ) {
        let tempLesson = JSON.parse(JSON.stringify(lesson));
        tempLesson["isUserPayed"] = false;
        tempLesson["examStatus"] = tempLesson.examStatus || null;
        console.log(tempLesson);
        tempLesson.priority = this.selectedLessons.length + 1;
        this.selectedLessons.push(tempLesson);
      }
    },
    selectedBorderClass(lessonId) {
      if (
        this.selectedLessons?.findIndex((item) => item.lessonId == lessonId) >
        -1
      ) {
        // Include this lesson
        return "success";
      } else {
        // Does not include this lesson
        return "black";
      }
    },
    setNewOrder(event) {
      // Check if any index has changed
      if (event.oldIndex != event.newIndex) {
        this.arrayMove(this.selectedLessons, event.oldIndex, event.newIndex);
      }
    },
    async deleteASingleRoadmapById() {
      try {
        this.isLoading = true;
        let _this = this;
        let deleteARoadmapGroup = new DeleteARoadmapGroup(_this);
        deleteARoadmapGroup.setRequestParam({ id: _this.$route.params.id });
        await deleteARoadmapGroup.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد",
                icon: "Trash2Icon",
                variant: "success",
                text: "نقشه راه با موفقیت حذف شد",
              },
            });
            _this.$router.push("/students/roadmaps/list");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.message || "لطفا دوباره امتحان کنید!",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getASingleRoadmapById() {
      if (this.$route.params.id) {
        try {
          this.isLoading = true;
          let _this = this;
          let getRoadmapById = new GetRoadmapById(_this);
          getRoadmapById.setRequestParam({ id: _this.$route.params.id });
          await getRoadmapById.fetch((res) => {
            _this.roadmapDetails = res;
            if (
              _this.roadmapDetails.roadMapGroupSimpleCreateUpdateDetaileDTOs
            ) {
              var tempArr =
                _this.roadmapDetails.roadMapGroupSimpleCreateUpdateDetaileDTOs.sort(
                  (a, b) => a.priority - b.priority
                );
              tempArr.forEach((element, index) => {
                element.priority = index + 1;
              });

              _this.selectedLessons = JSON.parse(JSON.stringify(tempArr));
            }
          });
        } catch (error) {
          console.error(error);
        } finally {
          this.isLoading = false;
        }
      }
    },
    makeAllPassed(checked) {
      const cloneOBj =
        this.selectedLessons && this.selectLesson.length > 0
          ? this.selectedLessons
          : [];
      cloneOBj.forEach((item) => {
        if (checked) {
          item.examStatus = 4;
        } else {
          item.examStatus = null;
        }
      });
    },
    makeAllBought(checked) {
      const cloneOBj = this.selectedLessons ?? [];

      cloneOBj.forEach((item) => {
        item.isUserPayed = checked;
      });
    },
    makeAllRequired(checked) {
      const cloneOBj = this.selectedLessons ?? [];

      cloneOBj.forEach((item) => {
        item.isRequired = checked;
      });
    },
  },
  computed: {
    sortedLessonList() {
      if (this.lessonsList && this.lessonsList.length > 0) {
        return this.lessonsList.sort((a, b) => b.priority - a.priority);
      }
    },
    sortedSelectedLessons() {
      if (this.selectedLessons && this.selectedLessons.length > 0) {
        return this.selectedLessons.sort((a, b) => a.priority - b.priority);
      }
    },
    isAllBought() {
      const cloneOBj = this.selectedLessons ?? [];
      return cloneOBj.every((item) => item.isUserPayed);
    },
    isAllPassed() {
      const cloneOBj = this.selectedLessons ?? [];
      return cloneOBj.every(
        (item) => item.examStatus == 4 || item.examStatus == 2
      );
    },
    isAllRequired() {
      const cloneOBj = this.selectedLessons ?? [];
      return cloneOBj.every((item) => item.isRequired);
    },
  },
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    BFormRadio,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    Draggable,
    BFormRow,
    BContainer,
  },
};
import { GetASingleStudentLanguage } from "../../../libs/Api/StudentLanguage";
import { GetIndependentLessonsList } from "@/libs/Api/IndependentLesson";
import { GetLiteUserById } from "@/libs/Api/Users";

import {
  GetRoadmapById,
  CreateOrUpdateRoadmap,
  DeleteARoadmapGroup,
} from "@/libs/Api/RoadmapGroupSimple";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Draggable from "vuedraggable";

import {
  BCard,
  BCardText,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BFormRadio,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BFormRow,
  BContainer,
} from "bootstrap-vue";
</script>
